import { useSelector } from 'react-redux';
import JunoButton from '../common/JunoButton';
import useDownloadAccountConfirm from '../../hooks/useDownloadAccountConfirm';

const AccountConfirmation = () => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const [generatePDF] = useDownloadAccountConfirm();

    return (
        <>
            <p className="px-6 py-4 self-stretch text-text text-sm font-semibold leading-5">
                Account Confirmation
            </p>

            <div className="flex justify-between items-center !p-5 self-stretch rounded-md bg-card-bg mx-6 mt-3 mb-6">
                <div className="flex items-center gap-3">
                    <img
                        src={`${imageBaseUrl}/common/pdfIcon.svg`}
                        alt="pdf"
                        className="w-12 h-12"
                    />
                    <div className="flex flex-col gap-1">
                        <p className="text-text text-sm font-semibold leading-5 uppercase">
                            Download Account confirmation.pdf
                        </p>
                    </div>
                </div>

                <JunoButton
                    className="!w-28 !text-sm font-semibold text-text "
                    type="widget"
                    onClick={generatePDF}>
                    DOWNLOAD
                </JunoButton>
            </div>
        </>
    );
};

export default AccountConfirmation;
